import React, { useState, useRef, useEffect } from 'react'
import {
  Button, Grid, Typography, Modal, Fade, Box, Icon, Tabs, Tab, RadioGroup, IconButton, Popper, Radio, FormControlLabel, Checkbox, TextField, InputAdornment,
  List, ListItem, ListItemAvatar, Avatar, ListItemText, ListItemSecondaryAction, LinearProgress, ClickAwayListener
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import toast from 'react-hot-toast';
import { makeStyles, withStyles } from '@mui/styles';
import { getDashboarDetails } from '../../config/services/dashboards';
import DashboardChartLayoutV3 from '../../components/_report/dashboard/DashboardChartLayoutV3';
import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import { ReactComponent as ProfileIcon } from "../../assets/icons/profile-icon-1.svg";
import { ReactComponent as RightNavIcon } from "../../assets/icons/icon-angle-right-main.svg";
import { ReactComponent as LeftNavIcon } from "../../assets/icons/icon-angle-left-main.svg";
import { ReactComponent as DropDownIcon } from "../../assets/icons/icon-angle-down.svg";
import { ReactComponent as CalendarIcon } from "../../assets/icons/icon_calender.svg";
import { ReactComponent as SyllabusIcon } from "../../assets/icons/icon-syllabus.svg";
import GenericIcon from '../../assets/icons/Generic_Icon.svg'
import { ReactComponent as TimerIcon } from "../../assets/icons/icon-timer.svg";
import CancelButton from "../../assets/icons/icon-cancel.svg";
import ReactEcharts from "echarts-for-react";
import DatePicker from "react-datepicker";
import { DecryptData } from '../../utils/encryptDecrypt'
import UAParser from "ua-parser-js";
import getDataFromCube from '../../utils/getCubeData';
import { getMeasuresList } from '../../config/services/measures';
import _ from 'lodash';
import { getDataSetDetails } from '../../config/services/datasets';
import Loader from '../Loader';
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import iconsData from '../../utils/subjectsIconsData'
import { ReactComponent as ReportChart } from "../../assets/icons/icon-report-data.svg"
import { multiLangData, handleLanguageChange, lang, setLanguage, updateLanguage } from '../../utils/multiLangDashboardV2Data';
import settings from "../../config/settings";
import moment from 'moment'
import { useLocation } from 'react-router-dom'
import { setHours, setMinutes } from 'date-fns'
import { isArrayEqual } from '../../utils/Reusables';
import { PORFILE_AVATAR, SUBJECT_ICON } from '../../constants/externalUrls'
import { getConfig } from '../../config/services/config';
import { configConsumerProps } from 'antd/lib/config-provider';

import { CarouselPrevArrow, CarouselNextArrow, isMobileView } from "./../../utils/Reusables";
import Slider from "react-slick";
import {Skeleton} from '@mui/material';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
}));


export default function ChartDashboardV2() {

  const {env,STUDENT_DASHBOARD_QUERY,STUDENT_DASHBOARD_ID,STUDENT_DASHBOARD_CALCULATED_FIELDS} = settings
  const [layout, setLayout] = useState([[]]);
  const bodyRef = React.createRef();
  const [sheetsAvailable, setSheetsAvailable] = useState([]);
  const [selectedSheetIndex, setSelectedSheetIndex] = useState(Number(localStorage.getItem('selectedSheetIndex')) || 0);
  const [dashBoardDetails, setDashBoardDetails] = useState([])
  const [filterOptions, setFilterOptions] = useState([]);
  const [valueList, setValueList] = useState([]);

  const [profiles, setProfiles] = useState([]);
  const [currentProfile, setCurrentProfile] = React.useState("all");
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 0;
  const [statistics, setStatstics] = useState([]);
  const [statsCardClasses, setStatsCardClasses] = useState(["first", "second", "third", "fourth"]);
  const [keyAreas1, setKeyAreas1] = useState([]);
  const [keyAreas2, setKeyAreas2] = useState([]);
  const [deviceType, setDeviceType] = useState('desktop');
  const [carousalCards, setCarousalCards] = useState(4);
  const [carousalWidth, setCarousalWidth] = useState('100%');
  const [currentUser, setCurrentUser] = useState(DecryptData(localStorage.getItem('s_uuid')) || '')
  const [selectedSubjects, setSelectedSubjects] = useState([])
  const [loading, setLoading] = useState(false)
  const [noDataKeyArea2, setNoDataKeyArea2] = useState(false)
  const [noDataKeyArea1, setNoDataKeyArea1] = useState(false)
  const [selectedProfile, setSelectedProfile] = useState([])
  const [profileReportIds, setProfileReportIds] = useState([])
  const [selectedTab, setSelectedTab] = useState('all.0')
  const [learningProfileMapping, setLearningProfileMapping] = useState([])
  const [showKeyMarksPerformance, setshowKeyMarksPerformance] = useState(true)
  const [showKeyTimePerformance, setshowKeyTimePerformance] = useState(true)
  const [maxStartDate, setMaxStartDate] = useState(Date.now())
  const [chevronVisibility, setChevronVisibility] = useState(true)
  const [minEndDate, setMinEndDate] = useState(new Date("01/01/2021"))
  const [isSameDayStartTime, setIsSameDayStartTime] = useState(false)
  const [disabledProp, setDisabledProp] = useState(false)
  const [isSameDayEndTime, setIsSameDayEndTime] = useState(false)
  const search = useLocation().search;
  const language = new URLSearchParams(search).get('lang');
  const [tempFilterState, setTempFilterState] = useState([])
  const [subjectIconData,setSubjectIconData] = useState([])
  const [dashboardId, setDashboardId] = useState('')
  const [staticDashboardQuery, setStaticDashboardQuery] = useState([])
  const [staticProfileMapping,setStaticProfileMapping] = useState([])
  const [staticStDate,setStaticStDate] = useState('')
  const [staticEdDate,setStaticEdDate] = useState('')
  const [loadProfile, setLoadProfile] = useState(false)
  const chartSlider = useRef(null);



  setLanguage(language)

  let { state } = useLocation();
  if (language) {
    updateLanguage(language)
  }
  else if (state) {
    updateLanguage(state)
  }
  else if (!language && !state) {
    updateLanguage('en')
  }

  const MultiSelectRow = ({ index, style, data }) => {
    const item = data[index];
    return <div style={style} key={item}>
      <FormControlLabel title={item} className="text-small menu-item flex" label={item}
        control={<Checkbox className="form_checkbox" size="small"
          checked={selectedSubjects.indexOf(item) > -1}
          value={item}
          onChange={handleSubjectFilterChange} />} />
    </div>
  }


  useEffect(() => {
    windowResized();
    window.addEventListener('resize', windowResized);
    let userAgent = navigator.userAgent;
    const parser = new UAParser();
    parser.setUA(userAgent);
    const result = parser.getResult();
    const deviceTypeParser = (result.device && result.device.type) || "desktop";
    setDeviceType(deviceTypeParser);

    if (!currentUser && localStorage.getItem('uuid')) {
      currentUser = DecryptData(localStorage.getItem('uuid'))
      setCurrentUser(currentUser)
    }
    else if (!currentUser && localStorage.getItem('t_uuid')) {
      currentUser = DecryptData(localStorage.getItem('t_uuid'))
      setCurrentUser(JSON.parse(currentUser))
    }
    else if (!currentUser && localStorage.getItem('s_uuids')) {
      currentUser = DecryptData(localStorage.getItem('s_uuids'))
      setCurrentUser(JSON.parse(currentUser))
    }
    else if (!currentUser && localStorage.getItem('emUserId')) {
      currentUser = DecryptData(localStorage.getItem('emUserId'))
      setCurrentUser(currentUser)
    }

    getConfigDetails()
    getSubjectIconData()
    setUserProfile(currentUser)


    // fetchDashboardDetails();
    // getCustomQueryData()


  }, []);

  React.useLayoutEffect(() => {
    document.body.classList.add("embed-reports-page");
    if (window.self != window.top) {
      document.body.classList.add("embed-reports-page-iframe");
    }
  }, []);

  useEffect(()=>{
  if(dashboardId)
    fetchDashboardDetails()
},[dashboardId])


  useEffect(() => {

    if (sheetsAvailable[selectedSheetIndex]?.reports && profiles.length) {
      let filterArr = {
        operator: 'equals',
        values: profiles.map(p => p?.learningProfileId),
        dataSetType: 'DIMENSION',
        filterType: 'profile_filter'
      }
      let schoolCodeFilterArr = {
        operator: 'equals',
        values: profiles.map(p => p?.schoolCode),
        dataSetType: 'DIMENSION',
        filterType: 'schoolCode_filter'
      }

      let profileIdArr = {
        operator: 'equals',
        values: profiles.map(p => p?.profileId),
        dataSetType: 'DIMENSION',
        filterType: 'profileId_filter'
      }

      for (let report of sheetsAvailable[selectedSheetIndex]?.reports) {

        const reportFilter = report?.reportFilters;

        const profileFilter = reportFilter.find(filter => filter?.filterType === 'profile_filter')

        const schoolCodeFilter = reportFilter.find(filter => filter?.filterType === 'schoolCode_filter')

        const profileIdFilter = reportFilter.find(filter => filter?.filterType === 'profileId_filter')

        let dataSetName = null;
        if (report.dimensions?.length > 0) {
          dataSetName = report.dimensions[0]?.fieldName?.split('.')[0];
        }
        else if (report.measures?.length > 0) {
          dataSetName = report.measures[0]?.fieldName?.split('.')[0];
        }

        setLoading(true)

        filterArr.member = `${dataSetName}.learningProfileId`
        if (!profileFilter) {
          reportFilter.push(filterArr)
        }
        else {
          profileFilter.values = profiles.map(p => p?.learningProfileId)
        }

        schoolCodeFilterArr.member = `${dataSetName}.schoolCode`
        if (!schoolCodeFilter) {
          reportFilter.push(schoolCodeFilterArr)
        }
        else {
          schoolCodeFilter.values = profiles.map(p => p?.schoolCode)
        }

        profileIdArr.member = `${dataSetName}.profileId`
        if (!profileIdFilter) {
          reportFilter.push(profileIdArr)
        }
        else {
          profileIdFilter.values = profiles.map(p => p?.profileId)
        }

      }
      let newArray = [...sheetsAvailable];
      setSheetsAvailable(newArray);
      setCurrentProfile('all');
      setSelectedProfile(profiles)

    }

  }, [profiles,sheetsAvailable[selectedSheetIndex]?.reports])


  const handleProfileChange = async (event, itm) => {
    setSelectedSubjects([])
    setStartDate(null)
    setEndDate(null)
    setTempFilterState([])


    let indx;
    let profil;
    if (itm) {
      profil = itm.split('.')[0]
      indx = itm.split('.')[1]
    }
    let profile = []
    if (profil === "all") {
      profile = profiles
    }
    else if (profil) {
      const profileObj = profiles.find((ele, index) => ele && ele?.profile === profil && index == indx)
      profile.push(profileObj)
    }

    if (profile.length) {
      getCustomQueryData(profile, null, null, 'profileChange')
      setSelectedProfile(profile)

      let filterArr = {
        operator: 'equals',
        values: profile?.map(p => p?.learningProfileId),
        dataSetType: 'DIMENSION',
        filterType: 'profile_filter'
      }

      let schoolCodeArr = {
        operator: 'equals',
        values: profile?.map(p => p?.schoolCode),
        dataSetType: 'DIMENSION',
        filterType: 'schoolCode_filter'
      }

      let profileIdArr = {
        operator: 'equals',
        values: profile?.map(p => p?.profileId),
        dataSetType: 'DIMENSION',
        filterType: 'profileId_filter'
      }




      //////////

        


      //////////


      for (let report of sheetsAvailable[selectedSheetIndex]?.reports) {

        const reportFilter = report?.reportFilters;
        const profileFilter = reportFilter.find(filter => filter?.filterType === 'profile_filter')
        const schoolCodeFilter = reportFilter.find(filter => filter?.filterType === 'schoolCode_filter')
        const profileIdFilter = reportFilter.find(filter => filter?.filterType === 'profileId_filter')

        let subjectFilterIndex = reportFilter.findIndex(filter => filter?.filterType === 'subject_filter')
        if (subjectFilterIndex >= 0) {
          reportFilter.splice(subjectFilterIndex, 1)
        }

        let dateFilterIndex = reportFilter.findIndex(filter => filter?.filterType === 'date_filter')
        if (dateFilterIndex >= 0) {
          reportFilter.splice(dateFilterIndex, 1)
        }

        let dataSetName = null;
        if (report.dimensions?.length > 0) {
          dataSetName = report.dimensions[0]?.fieldName?.split('.')[0];
        }
        else if (report.measures?.length > 0) {
          dataSetName = report.measures[0]?.fieldName?.split('.')[0];
        }
        const list = await getMeasuresList({ dataSetId: report?.dataSetId })
        const measureList = list?.result
        if (measureList && measureList?.length) {
          const isMeas = measureList.find(meas => meas?.name === 'learningProfileId')
          const isCode = measureList.find(meas => meas?.name === 'schoolCode')
          const isProfId = measureList.find(meas => meas?.name === 'profileId')
          if (isMeas && isCode && isProfId) {
            if (!loading) {
              setLoading(true)
            }
            filterArr.member = `${dataSetName}.${isMeas?.name}`
            schoolCodeArr.member = `${dataSetName}.${isCode?.name}`
            profileIdArr.member = `${dataSetName}.${isProfId?.name}`
            if (!profileFilter) {
              reportFilter.push(filterArr)
            }
            else {
              profileFilter.values = profile?.map(p => p?.learningProfileId)
            }

            if (!schoolCodeFilter) {
              reportFilter.push(schoolCodeArr)
            }
            else {
              schoolCodeFilter.values = profile?.map(p => p?.schoolCode)
            }

            if (!profileIdFilter) {
              reportFilter.push(profileIdArr)
            }
            else {
              profileIdFilter.values = profile?.map(p => p?.profileId)
            }
          }
        }

      }

      let newArray = [...sheetsAvailable];
      setSheetsAvailable(newArray);
      setCurrentProfile(profil);
      setSelectedTab(itm)
      setLoading(false)
    }

  };
  // const carousalResponsive = {
  //   desktop: {
  //     breakpoint: { max: 3000, min: 1024 },
  //     items: 4,
  //     //slidesToSlide: 1,
  //   },
  //   mobile: {
  //     breakpoint: { max: 1024, min: 240 },
  //     items: 2,
  //     //slidesToSlide: 1,
  //   }
  // };
  const carousalResponsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

  const windowResized = () => {

    if (window.innerWidth < 400) {
      setCarousalCards(2);
      setChevronVisibility(false);
    } else if (window.innerWidth < 639) {
      setCarousalCards(2);
      setChevronVisibility(false);
    } else if (window.innerWidth < 1024) {
      setCarousalCards(3);
      setChevronVisibility(true);
    } else if (window.innerWidth < 1200) {
      setCarousalCards(3);
      setChevronVisibility(true);
    } else {
      setCarousalCards(4);
      setChevronVisibility(true);
    }

    if (window.innerWidth < 600) {
      setCarousalWidth(window.innerWidth - 40);
    } else {
      setCarousalWidth('100%');
    }

  }
  
  useEffect(() =>{

    if(staticDashboardQuery.length && profiles.length) {

      let filterArr = {
        operator: 'equals',
        values: profiles.map(p => p?.learningProfileId),
        dataSetType: 'DIMENSION',
        filterType: 'profile_filter'
      }
      let schoolCodeFilterArr = {
        operator: 'equals',
        values: profiles.map(p => p?.schoolCode),
        dataSetType: 'DIMENSION',
        filterType: 'schoolCode_filter'
      }

      let profileIdArr = {
        operator: 'equals',
        values: profiles.map(p => p?.profileId),
        dataSetType: 'DIMENSION',
        filterType: 'profileId_filter'
      }

      getCustomQueryData(undefined, { profile: filterArr, schoolCode: schoolCodeFilterArr, profileId: profileIdArr})
    }
  },[staticDashboardQuery, profiles])

  const getConfigDetails = async () => {
     const response = await getConfig();
    if(response?.result) {
    const { staticReports, staticDashboardId, staticStartDate,staticEndDate,staticProfileMapping}  = response?.result;

    setDashboardId(staticDashboardId)
    setStaticProfileMapping(staticProfileMapping)
    setStaticDashboardQuery(staticReports)
  }
}



  const setUserProfile = async (s_uuid) => {
    if (s_uuid) {

      const filters = [{ member: 'UserLearningProfileProfile.uuid', operator: 'equals', values: [typeof s_uuid === 'string' ? s_uuid.trim() : ''] },{ member: 'UserLearningProfileProfile.status', operator: 'equals', values: ["1"] }]
      const members = ["UserLearningProfileProfile.profileName", "UserLearningProfileProfile.schoolCode", "UserLearningProfileProfile.learningProfileId", "UserLearningProfileProfile.avatarId", "UserLearningProfileProfile.learningProfile","UserLearningProfileProfile.profileId"]
      setLoading(true)
      const data = await getDataFromCube(undefined, undefined, filters, "static_dashboard", members);
      if (data?.length && Object.keys(data[0]).length) {
        const profileData = data.map(ele => {
          return {
            profile: ele["UserLearningProfileProfile.profileName"],
            profileId: ele["UserLearningProfileProfile.profileId"],
            learningProfileId: ele["UserLearningProfileProfile.learningProfileId"],
            schoolCode: ele['UserLearningProfileProfile.schoolCode'],
            avatarId: ele["UserLearningProfileProfile.avatarId"]
          }
        })
        setProfiles(profileData)
        getSubjectFilterData(profileData)

        const learningProfileMappedArr = data.map(ele => {
          return {
            profileName: ele["UserLearningProfileProfile.profileName"],
            learningProfile: ele["UserLearningProfileProfile.learningProfile"]
          }
        })
        setLearningProfileMapping(learningProfileMappedArr)
        setLoadProfile(true)
      }
      else {
        getCustomQueryData()
        setProfiles([])
        setLoadProfile(true)

      }
    }
  }


  const getSubjectFilterData = async (profileData) => {
    const filters = [{ member: 'LearnActivityLog.learningProfileId', operator: 'equals', values: profileData.map(p => p?.learningProfileId) },{ member: 'LearnActivityLog.profileId', operator: 'equals', values: profileData.map(p => p?.profileId) }
    ]
    const members = "LearnActivityLog.subject"
    const data = await getDataFromCube(undefined, undefined, filters, "static_dashboard", members);
    if (data?.length) {
      let subjectList = data.map(d => d['LearnActivityLog.subject'])
      setSubjectFilterData(subjectList)
    }

  }
  const circularProgressOption = (data) => ({
    series: [
      {
        type: "gauge",
        smooth: true,
        radius: "100%",
        startAngle: 90,
        endAngle: -270,
        center: ["50%", "50%"],
        min: 0,
        max: 100,
        itemStyle: {
          color: "#fff"
        },
        progress: {
          show: true,
          roundCap: true,
          width: 5
        },
        pointer: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            width: 5,
            color: [[1, '#fff']],
            opacity: 0.5
          }
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          show: false
        },
        title: {
          show: false,
          width: 90,
          offsetCenter: ["75", "-10"],
          overflow: "break"
        },
        detail: {
          offsetCenter: [0, 0],
          lineHeight: 16,
          valueAnimation: true,
          color: "#fff",
          fontSize: isMobileView() ? "18px" : "24px",
          formatter: function (v) {
            return [v, "%"].join("");
          },
          rich: {
            score: {
              color: "#fff",
              fontSize: 12
            },
            status: {
              color: "#fff",
              fontSize: 12
            }
          }
        },
        data
      }
    ]
  });

  const BorderLinearProgress = withStyles((theme) => ({
    root: {
      height: 3,
      borderRadius: 4,
    },
    colorPrimary: {
      backgroundColor: '#dedede',
    },
    bar: {
      borderRadius: 5,
      backgroundColor: '#F45E29',
    },
  }))(LinearProgress);

  const useStyles = makeStyles((theme) => ({
    fieldMenu: {
      boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
    },
    fieldBtn: {
      position: 'absolute',
      right: '5px',
      bottom: '3px',
      cursor: 'pointer',
    },
    reportFieldList: {
      width: '100%',
      backgroundColor: '#fff',
      maxHeight: '350px',
      minHeight: '350px',
      marginBottom: '1rem',
      boxShadow: '0px 3px 6px #00000029',
      overflow: 'auto',
      marginTop: '5px',
      borderRadius: '4px',
    },
    bgWhite: {
      backgroundColor: '#fff',
      borderRadius: '4px',
    },
    reportGraphs: {
      height: 'fit-content',
      minHeight: '500px',
      height: '100%',
      borderRadius: '8px',
    },
    reportsSelectFilter: {
      background: "#000",
      '&:hover': {
        background: "#f1f1f1",
      },
      '&.MuiFormLabel-root.Mui-focused': {
        color: 'red',
      },
    },
    reportContentWrapper: {
      padding: '0rem',
      marginTop: '0rem',
      [theme.breakpoints.down('lg')]: {
        padding: '0rem',
      },
      ['@media (max-width:1400px)']: {
        padding: '0rem',
      }
    },
    searchFieldListItem: {
      paddingTop: '0.6rem',
      paddingBottom: '0.6rem',
      '&:hover': {
        background: "#f1f1f1",
        zIndex: 9,
      },
    }

  }));
  const classes = useStyles()

  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [reportsList, setReportsList] = useState([])

  const handleCustomDateFilter = (query, type = undefined, queryType) => {
    let filter;
    let clonedStartDate = _.clone(startDate)
    let clonedEndDate = _.clone(endDate)
    if (queryType === 'profileChange') {
      clonedStartDate = null
      clonedEndDate = null
    }

    if (clonedStartDate && clonedEndDate) {
      filter = {
        operator: "inDateRange",
        values: [clonedStartDate, clonedEndDate],
      }
    }
    else if (clonedStartDate && !clonedEndDate) {
      filter = {
        operator: "afterDate",
        values: [clonedStartDate],
      }
    }
    else if (!clonedStartDate && clonedEndDate) {
      filter = {
        operator: "beforeDate",
        values: [clonedEndDate],
      }
    }
    

    // }

    if(filter) {

    let dataSetName = query?.dimensions?.length ? query?.dimensions?.[0].split('.')[0] : query?.measures[0].split('.')[0];

    if (filter) {
      if (query && query?.filters?.length) {
        let exist = query?.filters.find(filter => filter?.member.split('.')[1] === 'createDate' || filter?.member.split('.')[1] === 'dateTime');

        if (exist) {
          exist.operator = filter?.operator;
          exist.values = filter?.values
        }
        else {
          filter.member = `${dataSetName}.${type === 'progressReport' || type === 'attendance' ? 'createDate' : 'dateTime'}`
          query?.filters.push(filter)
        }
      }
      else {
        filter.member = `${dataSetName}.${type === 'progressReport' || type === 'attendance' ? 'createDate' : 'dateTime'}`
        query?.filters.push(filter)
      }

    }
    if (query?.filters.length) {
      let queryFilter = query?.filters.filter(f => (f && f?.member && f?.operator && f?.values && f?.values?.length))
      query.filters = queryFilter
    }
  }
    return query

  }

  const formatCustomData = (data) => {
    data.forEach(ele => {
      if (Object.keys(ele).length) {
        Object.keys(ele).forEach(k => {
          if (!ele[k]) {
            ele[k] = 0
          }
        })
      }
    })
    return data
  }

  const getCustomQueryData =  async (profile = undefined, defaultProfile = undefined, dateObj = undefined, type = undefined) => {
    let resArr = []
    setLoading(true)
    // let {highestPerformance,leastPerformance,overAllAccuracy,overAllAttendance,keyTimePerformanceMetrics,keyMarksPerformanceMetrics} = STUDENT_DASHBOARD_QUERY

    let {highestPerform ,leastPerform, Accuracy_Perc, overAllAtten, totalTimeMinute} = STUDENT_DASHBOARD_CALCULATED_FIELDS

    if(staticDashboardQuery && staticDashboardQuery?.length) {
      for(let reportQuery of staticDashboardQuery) {
          const {title, query, profileName, showLabel, label, dataKey} = reportQuery;
          if (title === 'Key Time Performance Metrics') {
              let timePerformanceMetrics = JSON.parse(query)
              timePerformanceMetrics = handleCustomDataFilter(timePerformanceMetrics, null , type)
              timePerformanceMetrics = handleCustomProfileDataFilter(timePerformanceMetrics, null, profile, defaultProfile)
              timePerformanceMetrics = handleCustomDateFilter(timePerformanceMetrics,null, type)
              let data5 = await getDataFromCube(undefined, undefined, undefined, "custom_query_data", timePerformanceMetrics);
              if (data5?.length) {
                  data5 = formatCustomData(data5)
                  let keyAreaStats1 = data5.sort((a, b) => a[dataKey] - b[dataKey]).map(ele => {
                  return {
                    subject: ele[label],
                    time: ele[dataKey]
                 }
                })
                setNoDataKeyArea1(false)
                setKeyAreas1(keyAreaStats1)
             }
            else {
                setKeyAreas1([])
                setNoDataKeyArea1(true)
             }
           }
            else if(title === 'Key Marks Performance Metrics') {
              let marksPerformanceMetrics = JSON.parse(query)
              marksPerformanceMetrics = handleCustomDataFilter(marksPerformanceMetrics, null , type)
              marksPerformanceMetrics = handleCustomProfileDataFilter(marksPerformanceMetrics, null , profile, defaultProfile)
              marksPerformanceMetrics = handleCustomDateFilter(marksPerformanceMetrics, undefined, type)
              let data6 = await getDataFromCube(undefined, undefined, undefined, "custom_query_data", marksPerformanceMetrics);
              if (data6?.length) {
                data6 = formatCustomData(data6)
                let keyAreaStats2 = data6.map(ele => {
                return {
                  subject: ele[label],
                  time: Math.round(ele[dataKey], 2)
                }
              })
              setNoDataKeyArea2(false)
              setKeyAreas2(keyAreaStats2)
            }
            else {
              setKeyAreas2([])
              setNoDataKeyArea2(true)
            }
         }
        else {
          let parsedQuery = JSON.parse(query);

           parsedQuery = handleCustomProfileDataFilter(parsedQuery, null, profile, defaultProfile)
           parsedQuery = handleCustomDateFilter(parsedQuery, undefined, null)

          let responseData = await getDataFromCube(undefined, undefined, undefined, "custom_query_data", parsedQuery);

          if(responseData?.length) {
            let data1 = formatCustomData(responseData)
            const perfData = data1.filter(d => d && d[dataKey] && d[dataKey] !== 'NaN')?.[0]

            if (perfData && Object.keys(perfData).length) {
             let stats = {
                  title: title,
                  data: Math.round(perfData[dataKey], 2),
                  label: showLabel ? label :  perfData[label],
                }
            resArr.push(stats)
          }
          else {
            let obj = {
              title: title,
              data: 0,
              label: showLabel ? label :  ''
            }
            resArr.push(obj)
          }
         } 
         else {
           let obj = {
              title: title,
              data: 0,
              label: showLabel ? label :  ''
            }
          resArr.push(obj)
         }
       }
     }
    setStatstics(resArr)
    }
    setLoading(false)
  }

  const handleCustomDataFilter = (query, type, queryType) => {
    let dataSetName = query?.dimensions?.length ? query?.dimensions?.[0].split('.')[0] : query?.measures[0].split('.')[0];

    let clonedSelectedSubjects = _.cloneDeep(selectedSubjects)
    if (queryType === 'profileChange') {
      clonedSelectedSubjects = []
    }

    if (query && query?.filters?.length) {
      let exist = query?.filters.find(filter => (filter?.member.split('.')[1] === 'subject' || filter?.member.split('.')[1] === 'subjectName') && filter?.operator === 'equals');
      if (exist) {
        exist.values = clonedSelectedSubjects
      }
      else {
        query?.filters.push({
          member: `${dataSetName}.${type === 'progressReport' ? 'subjectName' : 'subject'}`,
          operator: 'equals',
          values: clonedSelectedSubjects
        })
      }
    }
    else {
      query?.filters.push({
        member: `${dataSetName}.${type === 'progressReport' ? 'subjectName' : 'subject'}`,
        operator: 'equals',
        values: clonedSelectedSubjects
      })
    }


    if (query?.filters.length) {
      let queryFilter = query?.filters.filter(f => (f && f?.member && f?.operator && f?.values && f?.values?.length))
      query.filters = queryFilter
    }

    return query
  }

  const handleCustomProfileDataFilter = (query, type, profile, defaultProfile) => {

    let dataSetName = query?.dimensions?.length ? query?.dimensions?.[0].split('.')[0] : query?.measures[0].split('.')[0];
    if (defaultProfile) {
      let obj = {
        member: `${dataSetName}.learningProfileId`,
        operator: 'equals',
        values: defaultProfile?.profile?.values
      }
      let codeObj = {
        member: `${dataSetName}.schoolCode`,
        operator: 'equals',
        values: defaultProfile?.schoolCode?.values
      }
      let profileIdObj = {
        member: `${dataSetName}.profileId`,
        operator: 'equals',
        values: defaultProfile?.profileId?.values
      }
      query?.filters.push(obj)
      query?.filters.push(codeObj)
      query?.filters.push(profileIdObj)
    }
    else if (profile && !profile.includes(undefined)) {

      if (query && query?.filters?.length) {
        let exist = query?.filters.find(filter => filter?.member.split('.')[1] === 'learningProfileId');

        let profileIdExist = query?.filters.find(filter => filter?.member.split('.')[1] === 'profileId');

        let codeExist = query?.filters.find(filter => filter?.member.split('.')[1] === 'schoolCode');

        if (exist) {
          exist.values = profile.map(p => p?.learningProfileId)
        }
        else {
          query?.filters.push({
            member: `${dataSetName}.learningProfileId`,
            operator: 'equals',
            values: profile.map(p => p?.learningProfileId)
          })
        }

        if (codeExist) {
          codeExist.values = profile.map(p => p?.schoolCode)
        }
        else {
          query?.filters.push({
            member: `${dataSetName}.schoolCode`,
            operator: 'equals',
            values: profile.map(p => p?.schoolCode)
          })
        }

        if (profileIdExist) {
          profileIdExist.values = profile.map(p => p?.profileId)
        }
        else {
          query?.filters.push({
            member: `${dataSetName}.profileId`,
            operator: 'equals',
            values: profile.map(p => p?.profileId)
          })
        }

      }
      else {
        query?.filters.push({
          member: `${dataSetName}.learningProfileId`,
          operator: 'equals',
          values: profile.map(p => p?.learningProfileId)
        })

        query?.filters.push({
          member: `${dataSetName}.schoolCode`,
          operator: 'equals',
          values: profile.map(p => p?.schoolCode)
        })

        query?.filters.push({
          member: `${dataSetName}.profileId`,
          operator: 'equals',
          values: profile.map(p => p?.profileId)
        })
      }


      if (query?.filters.length) {
        let queryFilter = query?.filters.filter(f => (f && f?.member && f?.operator && f?.values && f?.values?.length))
        query.filters = queryFilter
      }

    }
    return query

  }

  const fetchDashboardDetails = async () => {
      const res = await getDashboarDetails({ dashboardId: dashboardId })
    let mappedDetails = res?.result?.sheets[0]?.reports.map(reportDetails => {
      let newObj = {
        ...reportDetails,
        ...reportDetails.reportId,
        reportId: reportDetails?.reportId?._id,
        label: reportDetails?.reportId?.reportName,
        value: reportDetails?.reportId?._id
      }
      return newObj
    })

    let mappedSheets = res?.result?.sheets.map(sheet => {
      sheet.reports = sheet.reports.map(reportDetails => {
        reportDetails.label = reportDetails?.reportId?.reportName
        reportDetails.value = reportDetails?.reportId?._id
        reportDetails = { ...reportDetails?.reportId, ...reportDetails }
        reportDetails.reportId = reportDetails?.reportId?._id
        return reportDetails
      })
      return sheet
    })

    setFilterOptionsHandler(mappedSheets)
    handleSelectReport(mappedDetails)
    setDashBoardDetails(mappedDetails)
    setSheetsAvailable(mappedSheets)
    parseValueListFromReport(mappedSheets)

  }

  const handleSelectAllSubjects = () => {
    let clonedSubjectsArray = _.clone(subjectFilterData)
    setSelectedSubjects(clonedSubjectsArray)
  }

  const handleUnSelectAllSubjects = () => {
    setSelectedSubjects([])
    setDisabledProp(true)
  }

  const applyFilterOnReports = async () => {
    setDisabledProp(false)
    getCustomQueryData();
    let tempState = selectedSubjects
    setTempFilterState(tempState);
    handleFilterInputClose(null, "applyFilter")
    let filterArr = {
      operator: 'equals',
      values: selectedSubjects,
      dataSetType: 'DIMENSION',
      filterType: 'subject_filter'
    }

    for (let report of sheetsAvailable[selectedSheetIndex]?.reports) {

      const reportFilter = report?.reportFilters;


      let dataSetName = null;
      if (report.dimensions?.length > 0) {
        dataSetName = report.dimensions[0]?.fieldName?.split('.')[0];
      }
      else if (report.measures?.length > 0) {
        dataSetName = report.measures[0]?.fieldName?.split('.')[0];
      }

      let subjectFilter;
      subjectFilter = reportFilter.find(f => f?.member === (dataSetName + '.' + 'subject' || f?.member === dataSetName + '.' + 'subjectName') && f?.operator === 'equals')
      if (!subjectFilter) {
        subjectFilter = reportFilter.find(filter => filter?.filterType === 'subject_filter')
      }

      const list = await getMeasuresList({ dataSetId: report?.dataSetId })
      const measureList = list?.result
      if (measureList && measureList?.length) {
        const isMeas = measureList.find(meas => meas?.name === 'subject' || meas?.name === 'subjectName')
        if (isMeas) {
          setLoading(true)
          filterArr.member = `${dataSetName}.${isMeas?.name}`
          if (!subjectFilter) {
            reportFilter.push(filterArr)
          }
          else {
            let selected = [...selectedSubjects]
            subjectFilter.values = Array.from(selected)
          }
        }
      }

    }

    let newArray = [...sheetsAvailable];
    setSheetsAvailable(newArray);
    setLoading(false)
  }

  const handleSubjectFilterChange = (e) => {

    const value = e?.target?.value
    const exist = selectedSubjects.find(ele => ele === value)
    if (exist) {
      let newSelected = selectedSubjects.filter(ele => ele !== value)
      if (!newSelected.length) {
        setDisabledProp(true)
      }
      else {
        setDisabledProp(false)
      }
      setSelectedSubjects(newSelected)
    }
    else {
      let newSelected = [...selectedSubjects]
      newSelected.push(value)
      setSelectedSubjects(newSelected)
    }

    if (!tempFilterState.length) {
      setDisabledProp(false)
    }
  }

  const parseValueListFromReport = (sheets) => {
    let FilterValuesList = []
    sheets[selectedSheetIndex]?.sheetFilter?.map(filterObj => {
      FilterValuesList.push(filterObj?.values)
    })
    setValueList(FilterValuesList)
  }


  const setFilterOptionsHandler = (sheets) => {
    let FilterOptionsList = []
    sheets[selectedSheetIndex]?.reports?.map(filterObj => {
      FilterOptionsList.push({
        report: filterObj,
        filterOptionList: filterObj?.reportFilters,
      })
    })

    setFilterOptions(FilterOptionsList)
  }



  const onLayoutChange = (layoutChange) => {
    let SheetLayout = Array.from(layout)
    SheetLayout[selectedSheetIndex] = layoutChange

    if (sheetsAvailable[selectedSheetIndex]?.reports) {
      sheetsAvailable[selectedSheetIndex].reports = sheetsAvailable[selectedSheetIndex]?.reports?.map((reportDetails, i) => {
        reportDetails.reportId = reportDetails?._id

        if (layoutChange && layoutChange[i])
          reportDetails = { ...reportDetails, ...layoutChange[i] }

        return reportDetails
      })
    }

    setLayout(SheetLayout);
  };

  const handleProfileReportIds = () => {

    let profileMappingData = []
    setshowKeyMarksPerformance(true)
    setshowKeyTimePerformance(true)
    const reportIds = []
    let learningProf = []


    if (learningProfileMapping.length && selectedProfile && selectedProfile?.length) {
      learningProfileMapping.forEach(prof => {
        const exist = selectedProfile.find(p => p?.profile === prof?.profileName)
        if (exist) {
          if (learningProf?.length) {
            if (!learningProf.find(p => p && p?.profile === exist?.profile))
              learningProf.push({ profile: prof?.learningProfile })
          }
          else {
            learningProf.push({ profile: prof?.learningProfile })
          }
        }
      })
    }
    if(staticProfileMapping?.length) {
      staticProfileMapping.forEach(mapping => {
        const {profileName, reportId} = mapping;
        profileMappingData.push({
            reportId, profileName
          })
      })
    }

    if(staticDashboardQuery?.length) {
     staticDashboardQuery.forEach(details => {
        const {title, profileName} = details;
        profileMappingData.push({
            reportId: title, profileName
          })
      })
    }

    if (learningProf.length && selectedProfile && selectedProfile.length && profileMappingData.length) {
      for (let selected of learningProf) {
        for (let prof of profileMappingData) {
          if (prof?.profileName && prof?.profileName.includes(selected?.profile)) {
            reportIds.push(prof?.reportId)
          }
        }
      }
      setProfileReportIds(reportIds);
    }
  }

  
  useEffect(() => {
    if(selectedProfile?.length) {
      getSubjectFilterData(selectedProfile)
    }
    if(selectedProfile?.length && learningProfileMapping?.length && staticDashboardQuery?.length && staticProfileMapping?.length ) {
      handleProfileReportIds()
    }

  }, [learningProfileMapping,staticDashboardQuery,staticProfileMapping,selectedProfile])

  const handleSelectReport = (value) => {
    if (sheetsAvailable[selectedSheetIndex]?.reports) {
      let newArray = Array.from(sheetsAvailable)
      let SheetIndex = newArray[selectedSheetIndex]?.reports?.findIndex(itm => itm._id === value._id)

      if (SheetIndex < 0) {
        newArray[selectedSheetIndex].reports.push(value)
      }
      else {
        newArray[selectedSheetIndex].reports.splice(SheetIndex, 1)
      }

      setSheetsAvailable(newArray)
      saveDashboardHaveChanges()
    }
  }

  const saveDashboardHaveChanges = () => {
    let DashboardHaveUnsavedChanges = localStorage.getItem('DashboardHaveUnsavedChanges')
    if (DashboardHaveUnsavedChanges !== 'true' || DashboardHaveUnsavedChanges !== true) {
      localStorage.setItem('DashboardHaveUnsavedChanges', true)
    }
  }

  const [subjectFilterData, setSubjectFilterData] = useState([]);
  const [filterInputEl, setFilterInputEl] = React.useState(null);
  const [filterInputOpen, setFilterInputOpen] = React.useState(false);
  const handleFilterInputClick = (event) => {
    setSelectFilterWidth(selectFiltersInput.current.clientWidth);
    if (event.currentTarget != filterInputEl) setFilterInputEl(event.currentTarget);
    if (!filterInputOpen) setFilterInputOpen(true);
  };
  const handleFilterInputClose = (e, type) => {
    if (e) e?.stopPropagation();
    setFilterInputEl(null);
    setFilterInputOpen(false);
    if (!tempFilterState.length && type !== "applyFilter") {
      setSelectedSubjects([])
      setDisabledProp(false)
    }
  };

  useEffect(() => {
    if (disabledProp && !filterInputOpen) {
      let selectedSubjects = [...tempFilterState];
      setSelectedSubjects(selectedSubjects)
    }
  }, [disabledProp, filterInputOpen])

  const filterInputId = filterInputOpen ? 'simple-popover' : undefined;
  const selectFiltersInput = useRef(null);
  const [selectFilterWidth, setSelectFilterWidth] = useState('200px');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');


  const getSubjectIconData = async () => {
     const members = ["SubjectRackName.rackNameId"
    ,"SubjectRackName.subject"]
      try {
         const data = await getDataFromCube(undefined, undefined, undefined, "static_dashboard", members);
          if (data?.length) {
            setSubjectIconData(data)
          }
      }
      catch(error) {
        console.log("Error occured",error)
      }
     
  }

    const mapSubjectIconData = (subject) => { 
    if(subjectIconData.length) {
      const item = subjectIconData.find(ele => ele['SubjectRackName.subject'] === subject)
      if (item) {
        let url = SUBJECT_ICON.replace('{ID}', item['SubjectRackName.rackNameId'])
        return  <Avatar src={url} style={{backgroundColor:'#0000'}}>
                  <img src={GenericIcon} alt="subject_icon" />
                </Avatar> 
      }
      else {
        return <Avatar src={GenericIcon} />
      }
   }
  }

  const handleProfileSpecificStats = () => {

    return statistics.map((item, i) => {
      let statsTitle;
      if (item?.title == 'High Performing') {
        statsTitle = 'Area of Strength'
      } else if (item?.title == 'Least Performing') {
        statsTitle = 'Area of Improvement'
      } else if (item?.title == 'Overall Accuracy') {
        statsTitle = 'Overall-Acc'
        statsTitle = lang === 'en' ? statsTitle.replace('-Acc', '') : statsTitle
      } else if (item?.title == 'Overall Attendance') {
        statsTitle = 'Overall'
      }
      if (selectedProfile && selectedProfile.length && profileReportIds && profileReportIds.length) {
        if (profileReportIds.includes(item?.title)) {

          return <div key={i} className={"er-stats-card " + statsCardClasses[i]}>
            <Grid container className="er-stats-card-grid"  >
              <Grid item xs={12} md={12} lg={6} display="flex" justifyContent="center" >
                <ReactEcharts option={circularProgressOption([item?.data])} style={{ height: (isMobileView() ? "70px" : "100px"), width: (isMobileView() ? "70px" : "100px") }} opts={{ renderer: 'svg' }} />
              </Grid>
              <Grid item xs={12} md={12} lg={6} className="er-stats-card-grid-content"  >
                <Box>
                  <Typography variant="body2" className="er-stats-card-title">{handleLanguageChange(statsTitle)}</Typography>
                  <Typography variant="body2" className="er-stats-card-subtitle">{handleLanguageChange(item?.label)}</Typography>
                </Box>
              </Grid>
            </Grid>
          </div>
        }
        else {
          return null
        }
      }
      else {
        return <div key={i} className={"er-stats-card " + statsCardClasses[i]}>
          <Grid container className="er-stats-card-grid"  >
            <Grid item xs={12} md={12} lg={6} display="flex" justifyContent="center" >
              <ReactEcharts option={circularProgressOption([item?.data])} style={{ height: (isMobileView() ? "70px" : "100px"), width: (isMobileView() ? "70px" : "100px") }} opts={{ renderer: 'svg' }} />
            </Grid>
            <Grid item xs={12} md={12} lg={6} className="er-stats-card-grid-content"  >
              <Box>
                <Typography variant="body2" className="er-stats-card-title">{handleLanguageChange(statsTitle)}</Typography>
                <Typography variant="body2" className="er-stats-card-subtitle">{handleLanguageChange(item?.label)}</Typography>
              </Box>
            </Grid>
          </Grid>
        </div>
      }


    })
  }

  const StringTruncate = (str, n) => {
    let val = (str.length > n) ? str.substr(0, n - 1) + '...' : str;
    return val;
  };

  const handleProfileSpecificKeyTime = () => {
    if (selectedProfile && selectedProfile.length && profileReportIds && profileReportIds.length) {
      if (profileReportIds.includes('Key Time Performance Metrics')) {
        if (noDataKeyArea1) {
          return <Box className="width-100 text-center" >
            <Box className='er-report-data-icon'><ReportChart /></Box>
            <Typography className="er-report-data-info" variant='h4'>{handleLanguageChange('No Data Found')}</Typography></Box>
        }
        else {
          return keyAreas1.map((item, i) => (
            <ListItem key={i}>
              <ListItemAvatar>
               {mapSubjectIconData(item?.subject)}
              </ListItemAvatar>
              <ListItemText className="label" primary={StringTruncate(item?.subject, 20)} />
              <ListItemSecondaryAction className="p-0">
                <IconButton className='form-icon-btn key-timer-btn' edge="end" aria-label="">
                  <TimerIcon />
                  <Typography className="action-label">{(item?.time ? item?.time : 0) + ' min'}</Typography>
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))
        }

      }
      else {
        setshowKeyTimePerformance(false)
        return ''
      }
    }
    else {
      if (noDataKeyArea1) {
        return <Box className="width-100 text-center" >
          <Box className='er-report-data-icon'><ReportChart /></Box>
          <Typography className="er-report-data-info" variant='h4'>{handleLanguageChange('No Data Found')}</Typography></Box>
      }
      else {
        return keyAreas1.map((item, i) => (
          <ListItem key={i}>
            <ListItemAvatar>
                  {mapSubjectIconData(item?.subject)}
            </ListItemAvatar>
            <ListItemText className="label" primary={StringTruncate(item?.subject, 20)} />
            <ListItemSecondaryAction className="p-0">
              <IconButton className='form-icon-btn' edge="end" aria-label="">
                <TimerIcon />
                <Typography className="action-label">{(item?.time ? item?.time : 0) + ' min'}</Typography>
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))
      }

    }
  }


  const handleProfileSpecificKeyMarks = () => {
    if (selectedProfile && selectedProfile.length && profileReportIds && profileReportIds.length) {
      if (profileReportIds.includes('Key Marks Performance Metrics')) {
        if (noDataKeyArea2) {
          return <Box className="width-100 text-center" >
            <Box className='er-report-data-icon'><ReportChart /></Box>
            <Typography className="er-report-data-info" variant='h4'>{handleLanguageChange('No Data Found')}</Typography></Box>
        }
        else {
          return keyAreas2.map((item, i) => (
            <ListItem key={i}>
              <Box>
                <ListItemAvatar>
                  {mapSubjectIconData(item?.subject)}

                </ListItemAvatar>
              </Box>
              <Box sx={{ width: '100%' }}>
                <Box>
                  <ListItemText className="label" primary={item?.subject} />
                  <ListItemSecondaryAction>
                    <IconButton className='form-icon-btn' edge="end" aria-label="">
                      <Typography className="action-label" >{(item?.time ? item?.time : 0) + '%'}</Typography>
                    </IconButton>
                  </ListItemSecondaryAction>
                </Box>
                <Box sx={{ width: '100%', mt: 1.5 }}>
                  <BorderLinearProgress variant="determinate" value={parseInt(item?.time)} />
                </Box>
              </Box>
            </ListItem>

          ))
        }

      }
      else {
        setshowKeyMarksPerformance(false)
        return null
      }
    }
    else {
      if (noDataKeyArea2) {
        return <Box className="width-100 text-center" >
          <Box className='er-report-data-icon'><ReportChart /></Box>
          <Typography className="er-report-data-info" variant='h4'>{handleLanguageChange('No Data Found')}</Typography></Box>
      }
      else {
        return keyAreas2.map((item, i) => (
          <ListItem key={i}>
            <Box>
              <ListItemAvatar>
                {mapSubjectIconData(item?.subject)}
              </ListItemAvatar>
            </Box>
            <Box sx={{ width: '100%' }}>
              <Box>
                <ListItemText className="label" primary={item?.subject} />
                <ListItemSecondaryAction>
                  <IconButton className='form-icon-btn' edge="end" aria-label="">
                    <Typography className="action-label" >{(item?.time ? item?.time : 0) + '%'}</Typography>
                  </IconButton>
                </ListItemSecondaryAction>
              </Box>
              <Box sx={{ width: '100%', mt: 1.5 }}>
                <BorderLinearProgress variant="determinate" value={parseInt(item?.time)} />
              </Box>
            </Box>
          </ListItem>

        ))
      }
    }
  }


  const handleStartDateReportFilter = async (date) => {
    
    if (moment(date).isValid()) {
      let edMonth, edDay, edYear, stMonth, stDay, stYear
      let minEdDate = date;
      setMinEndDate(minEdDate);
      setIsSameDayEndTime(true)
      if (endDate) {
        edMonth = new Date(endDate).getMonth()
        edDay = new Date(endDate).getDay()
        edYear = new Date(endDate).getFullYear()
        stMonth = new Date(minEdDate).getMonth()
        stDay = new Date(minEdDate).getDay()
        stYear = new Date(minEdDate).getFullYear()


        if (edMonth !== stMonth || edDay !== stDay || edYear !== stYear) {
          setIsSameDayStartTime(false)
        }
        else {
          setIsSameDayStartTime(true)
        }
      }
      else {
        setIsSameDayEndTime(true)
      }
      date = moment(date).format("YYYY-MM-DD HH:mm:ss")
    }
    else {
      setIsSameDayEndTime(false)
      setMinEndDate(new Date("01/01/2021"))
      date = ''
    }
    setStartDate(date);
    let filter = {}
    if (endDate && date) {
      filter = {
        operator: "inDateRange",
        values: [date, (endDate || staticEdDate)],
        dataSetType: 'DIMENSION',
        filterType: 'date_filter'

      }
    }
    else if (!date && endDate) {
      filter = {
        operator: "beforeDate",
        values: [endDate],
        dataSetType: 'DIMENSION',
        filterType: 'date_filter'
      }
    }
    else if (date && !endDate) {
      filter = {
        operator: "afterDate",
        values: [date],
        dataSetType: 'DIMENSION',
        filterType: 'date_filter'

      }
    }


    for (let report of sheetsAvailable[selectedSheetIndex]?.reports) {

      const reportFilter = report?.reportFilters;
      const dateFilter = reportFilter.find(filter => filter?.filterType === 'date_filter')
      let dataSetName = null;
      if (report.dimensions?.length > 0) {
        dataSetName = report.dimensions[0]?.fieldName?.split('.')[0];
      }
      else if (report.measures?.length > 0) {
        dataSetName = report.measures[0]?.fieldName?.split('.')[0];
      }
      const list = await getMeasuresList({ dataSetId: report?.dataSetId })
      const measureList = list?.result
      if (measureList && measureList?.length) {
        let isMeas;
        isMeas = measureList.filter(meas => meas?.name === 'createDate')[0]
        if (!isMeas) {
          isMeas = measureList.filter(meas => meas?.name === 'assignDate')[0]
        }
        if (isMeas) {
          setLoading(true)
          filter.member = `${dataSetName}.${isMeas?.name}`
          if (!dateFilter) {
            reportFilter.push(filter)
          }
          else {
            dateFilter.member = `${dataSetName}.${isMeas?.name}`
            dateFilter.values = filter?.values;
            dateFilter.operator = filter?.operator
          }
        }
      }

    }

    let newArray = [...sheetsAvailable];
    setSheetsAvailable(newArray);
    setLoading(false)
  }

  const handleEndDateReportFilter = async (date) => {
    if (moment(date).isValid()) {
      let edMonth, edDay, edYear, stMonth, stDay, stYear;
      let maxStDate = date
      setMaxStartDate(maxStDate)
      setIsSameDayStartTime(true)

      if (startDate) {
        edMonth = new Date(startDate).getMonth()
        edDay = new Date(startDate).getDay()
        edYear = new Date(startDate).getFullYear()
        stMonth = new Date(maxStDate).getMonth()
        stDay = new Date(maxStDate).getDay()
        stYear = new Date(maxStDate).getFullYear()


        if (edMonth !== stMonth || edDay !== stDay || edYear !== stYear) {
          setIsSameDayEndTime(false)
        }
        else {
          setIsSameDayEndTime(true)
        }
      } else {
        setIsSameDayStartTime(true)
      }

      date = moment(date).format("YYYY/MM/DD HH:mm:ss")
    }
    else {
      setIsSameDayStartTime(false)
      setMaxStartDate(Date.now())
      date = ''
    }
    setEndDate(date);
    let filter = {}
    if (startDate && date) {
      filter = {
        operator: "inDateRange",
        values: [startDate, date],
        dataSetType: 'DIMENSION',
        filterType: 'date_filter'

      }
    }
    else if (startDate && !date) {
      filter = {
        operator: "afterDate",
        values: [startDate],
        dataSetType: 'DIMENSION',
        filterType: 'date_filter'
      }
    }
    else if (!startDate && date) {
      filter = {
        operator: "beforeDate",
        values: [date],
        dataSetType: 'DIMENSION',
        filterType: 'date_filter'
      }
    }



    for (let report of sheetsAvailable[selectedSheetIndex]?.reports) {

      const reportFilter = report?.reportFilters;
      const dateFilter = reportFilter.find(filter => filter?.filterType === 'date_filter')
      let dataSetName = null;
      if (report.dimensions?.length > 0) {
        dataSetName = report.dimensions[0]?.fieldName?.split('.')[0];
      }
      else if (report.measures?.length > 0) {
        dataSetName = report.measures[0]?.fieldName?.split('.')[0];
      }
      const list = await getMeasuresList({ dataSetId: report?.dataSetId })
      const measureList = list?.result
      if (measureList && measureList?.length) {
        let isMeas = measureList.find(meas => meas?.name === 'createDate' || meas?.name === 'assignDate')

        if (isMeas) {
          setLoading(true)
          filter.member = `${dataSetName}.${isMeas?.name}`
          if (!dateFilter) {
            reportFilter.push(filter)
          }
          else {
            dateFilter.member = `${dataSetName}.${isMeas?.name}`
            dateFilter.values = filter?.values;
            dateFilter.operator = filter?.operator
          }
        }
      }

    }

    let newArray = [...sheetsAvailable];
    setSheetsAvailable(newArray);
    setLoading(false)
  }

  useEffect(() => {
    if (startDate || endDate || endDate==='' || endDate==='' )
      getCustomQueryData()
  }, [startDate, endDate])




  return (
    <RootStyle>
      <MainStyle>
        <Outlet />

        <Box className="embed-reports" >
          {loading && <Loader />}
          <Grid container mb={2} >
            <Grid container item alignItems="start" justifyContent="flex-start" sm={12} md={12} lg={12} >
              <Box className="er-heading" sx={{ pb: '2rem' }}>
                <Typography className="er-heading-title" variant="h2" noWrap>{handleLanguageChange("Reports")}</Typography>
              </Box>
            </Grid>

            <Grid className='er-heading-content' item alignItems="start" justifyContent="flex-start" sm={12} md={12} lg={12} >
              <Box className="er-content">
                <Typography className="er-heading-title" variant="h4" noWrap>{handleLanguageChange("Progress and Performance Reports")}</Typography>
                <Typography className="er-heading-subtitle" variant="p" >{handleLanguageChange("Comprehensive analysis to track your progress")}</Typography>
              </Box>
            </Grid>
            <Grid item alignItems="start" justifyContent="flex-start" sm={12} md={12} lg={12} >
              <Box className="er-profiles" sx={{ width: carousalWidth }}>
                <Tabs
                  value={selectedTab}
                  onChange={handleProfileChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                  TabIndicatorProps={{
                    style: {
                      display: "none",
                    },
                  }}
                >
                  { (profiles.length) ? <Tab
                    key="0"
                    className={"er-profile-title"}
                    //onClick={handleProfileChange}
                    value={`all.0`}
                    label={
                      <Box >
                        <Typography variant='h4' className="inline-item" >{handleLanguageChange('All')}</Typography>
                      </Box>
                    }>
                  </Tab> : null
                  }
                  {
                    profiles?.map((itm, i) => (

                      <Tab
                        key={i}
                        className={"er-profile-title"}
                        //onClick={handleProfileChange}
                        value={`${itm?.profile}.${i}`}
                        id={`${itm?.profile}.${i}`}
                        label={
                          <Box className='er-profiles-content'>
                            <Box sx={{ w: '35px', h: '35px' }}>
                              {/* <ProfileIcon className="inline-item" /> */}
                              <img src={PORFILE_AVATAR.replace('{ID}', itm?.avatarId)} alt="profile_icon" className="inline-item" />
                            </Box>

                            <Typography variant='h4' className="er-profiles-content-title inline-item" >{handleLanguageChange(itm?.profile)}</Typography>
                          </Box>
                        }>
                      </Tab>
                    ))
                  }
                </Tabs>
              </Box>
            </Grid>

            <Grid item alignItems="start" justifyContent="flex-start" sm={12} md={12} lg={12} className="width-100p" >
              {/* <Box className="er-content" sx={{mb:2}} >
                          <Typography className="er-heading-title" variant="h4" noWrap>{"Lorem ipsum dolor sit amet"}</Typography>
                      </Box> */}

              <Box className='item-carousel-container' sx={{ width: carousalWidth }}>

              <Box className={`chart-carousel ` + (isMobileView() ? 'chart-carousel-mobile' : `` )} sx={{ width: '100%', height: '100%' }}>
                  
                  <Slider
                    ref={chartSlider}
                    speed={500}
                    arrows={isMobileView() ? false : true}
                    slidesToScroll={1}
                    slidesToShow={carousalCards}
                    centerMode={false}
                    swipeToSlide={true}
                    infinite={false}
                    centerPadding={isMobileView() ? '10px' : '20px'}
                    nextArrow={isMobileView() ? null : <CarouselNextArrow />}
                    prevArrow={isMobileView() ? null : <CarouselPrevArrow />}
                  >
                    {
                      handleProfileSpecificStats()
                    }
                  </Slider>
                </Box>
              </Box>

            </Grid>

          </Grid>

          <Grid container item className='re-sr-filter-grid' alignItems="start" justifyContent="flex-start" spacing={2} sm={12} md={12} lg={12} my={2} >
            <Grid item xs={12} md={4} lg={4}>
              <>
                <Box className="select_filters_input er-input-filter" onClick={handleFilterInputClick} ref={selectFiltersInput} >
                  <Box style={{ overflow: 'hidden' }} className="select_filters_input_item" display="flex" alignItems="center">
                    <Typography variant='subtitle'>
                      {isArrayEqual(subjectFilterData, selectedSubjects) ? handleLanguageChange('All Subjects Selected') : selectedSubjects.length === 1 ? selectedSubjects[0] : selectedSubjects.length > 1 ? `${handleLanguageChange('Subject')} (${selectedSubjects.length})` : handleLanguageChange("Subject")}</Typography>
                  </Box>
                  <Box className="select_filters_input_item"><DropDownIcon /></Box>
                </Box>
                {
                filterInputOpen && <ClickAwayListener onClickAway={() => setFilterInputOpen(false)}>
                  <Popper
                    id={filterInputId}
                    open={filterInputOpen}
                    anchorEl={filterInputEl}
                    onClose={e => handleFilterInputClose(e)}
                    // anchorOrigin={{
                    //   vertical: 'bottom',
                    //   horizontal: 'left',
                    // }}
                    // PaperProps={{
                    //   classes: { root: 'filter-item-options' }
                    // }}
                    disabled={false}
                    placement="bottom-start"
                    disablePortal={false}

                  >
                    <Box className='filter-item-options quick-filter-popover'>
                      <Box className="filters-dropdown-item" sx={{ width: selectFilterWidth }}>
                        <Box className="filters-dropdown-item-header">

                          <Box className="select_filters_input_item">
                            <Typography className="filters-dropdown-item-label" >{handleLanguageChange("Subjects")}</Typography>
                          </Box>

                          <Box className="select_filters_input_item">
                            <IconButton className="form-icon-btn" color="secondary" onClick={(e) => handleFilterInputClose(e)}>
                              <img src={CancelButton} />
                            </IconButton>
                          </Box>
                        </Box>

                        <Box className="filters-dropdown-item-content">
                          <FormControlLabel className="text-small menu-item flex select-all-option" label="Select All"
                            control={<Checkbox className="form_checkbox" size="small" checked={isArrayEqual(subjectFilterData, selectedSubjects)} onChange={handleSelectAllSubjects} />} />

                          <RadioGroup name="controlled-radio-buttons-group" value={""} onChange={(e) => { }} >
                            <div className=" ">
                              <div className={`virtual-filter-div ` + ((subjectFilterData.length) ? 'filter-data-exists' : ``)}>
                                <AutoSizer>
                                  {({ height, width }) => (
                                    <FixedSizeList
                                      className="List"
                                      height={subjectFilterData?.length ? height : 20}
                                      itemCount={subjectFilterData?.length}
                                      width={width - 6}
                                      itemData={subjectFilterData}
                                      itemSize={35}
                                    >
                                      {MultiSelectRow}
                                    </FixedSizeList>
                                  )}
                                </AutoSizer>
                              </div>

                            </div>
                          </RadioGroup>
                        </Box>
                        <Box className="filters-dropdown-item-footer">
                          <Button sx={{ mr: 2 }} className="report_form_fltr_btn" variant='outlined' onClick={handleUnSelectAllSubjects} disabled={selectedSubjects?.length < 1} >Clear All</Button>
                          <Button onClick={applyFilterOnReports}
                            disabled={(!selectedSubjects.length && !disabledProp)} className="report_form_ui_btn submit" variant="contained">Apply</Button>
                        </Box>
                      </Box>
                    </Box>
                  </Popper>
                </ClickAwayListener>
                }
              </>
            </Grid>
            <Grid item xs={6} md={4} lg={4}>
              <DatePicker dateFormat="dd/MM/yyyy HH:mm:ss"  placeholderText={handleLanguageChange("Start Date")} className="report_form_ui_input_date er-input-filter"
                minDate={new Date("01-01-2021 00:00:00")}
                maxDate={maxStartDate}
                minTime={new Date("2021-01-01 00:00:00")}
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                onChangeRaw={(e) => e.preventDefault()}
                maxTime={!isSameDayStartTime ? moment.utc().endOf('day') : maxStartDate}
                selected={startDate ? new Date(startDate) : null} onChange={(date) => handleStartDateReportFilter(date)}
                isClearable
                customInput={
                  <TextField className="report_form_ui_input_date er-input-filter"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <CalendarIcon className="er-input-calendar-icon" />
                        </InputAdornment>
                      ),
                    }} />
                }
              />
            </Grid>

            <Grid item xs={6} md={4} lg={4}>
              <DatePicker dateFormat="dd/MM/yyyy HH:mm:ss" 
                minDate={minEndDate}
                maxDate={new Date()} placeholderText={handleLanguageChange("End Date")} className="report_form_ui_input_date er-input-filter"
                selected={endDate ? new Date(endDate) : null} onChange={(date) => handleEndDateReportFilter(date)}
                minTime={!isSameDayEndTime ? moment.utc().endOf('day') : setHours(setMinutes(new Date(), new Date(minEndDate).getMinutes()), new Date(minEndDate).getHours())}
                maxTime={new Date().setHours(23, 59, 59, 999)}
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                onChangeRaw={(e) => e.preventDefault()}
                isClearable
                customInput={
                  <TextField className="report_form_ui_input_date er-input-filter"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <CalendarIcon className="er-input-calendar-icon" />
                        </InputAdornment>
                      ),
                    }} />
                }
              />
            </Grid>

          </Grid>

          <Grid item alignItems="start" justifyContent="flex-start" sm={12} md={12} lg={12} mt={4} mb={2} >
            <Box className="er-content" >
              <Typography className="er-heading-title" variant="h4" noWrap>{handleLanguageChange("Subject-wise Analysis")}</Typography>
              <Typography className="er-heading-subtitle" variant="p" >{handleLanguageChange("Subject-wise data driven analysis to monitor your performance")}</Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={12}>
            <Box ref={containerRef} className={classes.reportGraphs}>


              {
                  dashboardId && sheetsAvailable?.length && sheetsAvailable[selectedSheetIndex]?.reports ?
                    <DashboardChartLayoutV3
                      onLayoutChange={onLayoutChange}
                      containerWidth={containerWidth}
                      selectedReports={sheetsAvailable[selectedSheetIndex]?.reports}
                      bodyRef={bodyRef}
                      handleSelectReport={handleSelectReport}
                      learningProfileMapping={learningProfileMapping}
                      currentProfile={currentProfile}
                      selectedProfile={selectedProfile}
                      profiles={profiles}
                      profileReportIds={profileReportIds}
                      staticDashboardQuery={staticDashboardQuery}
                      staticProfileMapping={staticProfileMapping}
                      loadProfile={loadProfile}
                      staticStDate={staticStDate}

                    /> : null}
            </Box>
          </Grid>

          <Grid item alignItems="start" justifyContent="flex-start" sm={12} md={12} lg={12} mt={4} mb={2} className='er-section-keyareas' >
            <Box className="er-content" >
              <Typography className="er-heading-title" variant="h4" noWrap>{handleLanguageChange("Key Areas of Improvement")}</Typography>
              <Typography className="er-heading-subtitle" variant="p" >{handleLanguageChange("Identify and work on weak areas to ace your exams")}</Typography>
            </Box>
          </Grid>

          <Grid container item spacing={2} sm={12} md={12} lg={12} mb={2} >
            {
              showKeyTimePerformance ? (
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Box className='er-keyareas'>
                    <Box className="er-keyareas-heading">
                      <Typography variant='h4' >{handleLanguageChange("Learn & Practice - Learn Progress")}</Typography>
                    </Box>
                    <Box className="er-keyareas-content">
                      <List className='er-keyareas-items'>
                        {


                          loading ? <Box className="width-100"> 
                                      <Skeleton className='progress-skeleton' animation="wave" />
                                      <Skeleton className='progress-skeleton half' animation="wave" />
                                    </Box> 
                                  :
                          handleProfileSpecificKeyTime() 

                        }
                      </List>
                    </Box>
                  </Box>

                </Grid>
              ) : null
            }
            {showKeyMarksPerformance ? (
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Box className='er-keyareas'>
                  <Box className="er-keyareas-heading">
                    <Typography variant='h4' >{handleLanguageChange("Test and Practice-Test Performance")}</Typography>
                  </Box>
                  <Box className="er-keyareas-content">
                    <List className='er-keyareas-items'>
                      {

                        loading ? <Box className="width-100" display="flex" justifyContent="center" alignItems="center"> <CircularProgress /></Box> :
                        handleProfileSpecificKeyMarks()

                      }
                    </List>
                  </Box>
                </Box>
              </Grid>
            ) : null
            }
          </Grid>


        </Box>
      </MainStyle>
    </RootStyle >

  )
}
